<%= form_with(model: solo, class: "contents") do |form| %>
  <% if solo.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(solo.errors.count, "error") %> prohibited this solo from being saved:</h2>

      <ul class="list-disc ml-6">
        <% solo.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :heat_id %>
    <%= form.text_field :heat_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": solo.errors[:heat_id].none?, "border-red-400 focus:outline-red-600": solo.errors[:heat_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :combo_dance_id %>
    <%= form.text_field :combo_dance_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": solo.errors[:combo_dance_id].none?, "border-red-400 focus:outline-red-600": solo.errors[:combo_dance_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :category_override_id %>
    <%= form.text_field :category_override_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": solo.errors[:category_override_id].none?, "border-red-400 focus:outline-red-600": solo.errors[:category_override_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :artist %>
    <%= form.text_field :artist, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": solo.errors[:artist].none?, "border-red-400 focus:outline-red-600": solo.errors[:artist].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :song %>
    <%= form.text_field :song, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": solo.errors[:song].none?, "border-red-400 focus:outline-red-600": solo.errors[:song].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :order %>
    <%= form.number_field :order, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": solo.errors[:order].none?, "border-red-400 focus:outline-red-600": solo.errors[:order].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
